export default () => {
  [...document.querySelectorAll(".js-newsletter-signup")].forEach((elForm) => {
    const successMessage = document.querySelector(
      ".js-newsletter-success-message",
    );
    const errorMessage = document.querySelector(".js-newsletter-error-message");

    // When the input is focused, hide any existing error messages
    elForm.querySelector("input").addEventListener("focus", () => {
      window.setTimeout(
        () => errorMessage.classList.remove("is-visible"),
        5000,
      );
    });

    elForm.addEventListener("submit", (e) => {
      e.preventDefault();
      // on submit, blur the input to remove floating placeholder text and allow
      // for accurate success/error display
      elForm.querySelector("button").focus();
      errorMessage.classList.remove("is-visible");

      const field = elForm.querySelector("input");
      const valid = !!field.value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+/i);

      if (!valid) {
        errorMessage.classList.add("is-visible");
        elForm.querySelector(".js-newsletter-error-response").innerText =
          "Email address is invalid";
        field.focus();
        return;
      }

      fetch(elForm.action, {
        body: new URLSearchParams(new FormData(elForm)).toString(),
        credentials: "same-origin",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            document
              .querySelectorAll(".js-newsletter-hideable")
              .forEach((hideable) => {
                hideable.style.display = "none";
              });
            successMessage.classList.add("is-visible");
            elForm.querySelector(".js-newsletter-success-response").innerText =
              data.message;
          } else {
            errorMessage.classList.add("is-visible");
            elForm.querySelector(".js-newsletter-error-response").innerText =
              data.message;
          }
        })
        .catch((err) => {
          console.log(err);
          errorMessage.classList.add("is-visible");
          elForm.querySelector(".js-newsletter-error-response").innerText =
            "An error has occurred.";
        });
    });
  });
};
